export default __webpack_public_path__ + "static/media/aboutChair.7a7e3e12.svg";